module.exports = __webpack_public_path__ + "img/APIGateway.2182baee.jpg";